import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper, {Autoplay,Navigation} from "swiper";
const [w,d,mq] = [window,document,window.matchMedia('(max-width: 901px)')];

class scrollEvent {
  constructor(){
    this.init();
  }
  init() {
    this.mainvisual();
    this.intro();
    this.service();
  }

  mainvisual() {
    let contHeader = d.querySelector('.content-header');
    let imgPaths = [
      '/assets/img/home/solu_img01@2x.png',
      '/assets/img/home/solu_img02@2x.jpg',
    ];
    let imgLoad = [];
    imgPaths.forEach( (path,i) => {
      imgLoad.push( new Promise( resolve => {
        let img = new Image();
        img.addEventListener('load', () => resolve());
        img.src = imgPaths[i];
      }));
    });
    Promise.all([...imgLoad]).then( () => {
      contHeader.classList.add('is-active');
    });
  }

  intro () {

    ScrollTrigger.create({
      trigger: '.solution-intro', //アニメーションが始まるトリガーとなる要素
      start: 'top top',
      end: 'bottom 25%',
      toggleClass: {targets: "html", className: "is-light-mode"},
      onLeave: () => {
        // d.documentElement.classList.toggle('is-light-mode');
        d.documentElement.classList.toggle('is-dark-mode');
      },
      onEnterBack: () => {
        d.documentElement.classList.remove('is-dark-mode');
      }
      // markers: true,
    });

  }

  service() {
    gsap.fromTo('.is-service02 .solution-service__img img:nth-child(1)', {
      y: '-25%'
    },{ //アニメーションしたい要素を指定
      y: '20%',
      scrollTrigger: {
        trigger: '.solution-service.is-service02',//アニメーションが始まるトリガーとなる要素
        start: 'top 150%', //アニメーションが始まる位置を指定
        end: 'bottom -30%',
        scrub: true,
        // markers: true,
      }
    });
    gsap.fromTo('.is-service02 .solution-service__img img:nth-child(2)', {
      y: '-25%'
    },{ //アニメーションしたい要素を指定
      y: '30%',
      scrollTrigger: {
        trigger: '.solution-service.is-service02',//アニメーションが始まるトリガーとなる要素
        start: 'top 120%', //アニメーションが始まる位置を指定
        end: 'bottom -30%',
        scrub: true,
        // markers: true,
      }
    });
  }
}

class caseCarousel {
  constructor(){
    this.init();
  }
  init() {
    let caseCarousel = {
      destroy() {}
    };
    let sliderContainer = d.querySelector('[data-plugin="carousel"].swiper');
    let sliderNavigation = d.querySelector('.block-case [data-role="navigation"]');
    let slideCount = d.querySelectorAll('[data-plugin="carousel"] .swiper-slide').length
    const swipeInit = () => {
      if( slideCount <= 1 ) {
        sliderContainer.classList.remove('swiper');
        sliderNavigation.remove();
        return false;
      }
      caseCarousel = new Swiper( sliderContainer, {
        modules: [Autoplay,Navigation],
        autoplay: {
          delay: 3500,
        },
        speed: 700,
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 1,
        navigation: {
          prevEl: '.block-case__navigation-prev',
          nextEl: '.block-case__navigation-next',
        },
      });
    }
    const swipeToggle = is_sp => is_sp? caseCarousel.destroy(false,true): swipeInit();
    swipeToggle(mq.matches);
    mq.addEventListener('change', e => swipeToggle(e.matches) );
  }
}

export default function SOLUTION(){
  d.addEventListener('DOMContentLoaded', () => {
    d.documentElement.classList.add('is-light-mode');
    new scrollEvent;
    new caseCarousel;
  });
}